import { prop, path, isNil, isEmpty, head } from "ramda";
import { SessionState, Session, Data } from "./types";
import { ApplicationState } from "../index";
import { stat } from "fs";

export function getToken(session: Session) {
  return path(["meta", "token"], session) || null;
}

export function getById(
  id: string | undefined,
  session: SessionState | undefined
): Session | undefined {
  return !isNil(id) && !isNil(session) && session.data && session.data.data
    ? ((session.data.data.find((x) => x.id === id) as unknown) as Session)
    : undefined;
}

export function getSession() {
  return (state: ApplicationState) => {
    const sessionState = !isNil(state.session.data?.data)
      ? state.session.data?.data[0]
      : undefined;
    return sessionState;
  };
}

export function isSessionDirty() {
  return (state: ApplicationState) =>
    (state.session.dirty && !state.session.isSecondUser) ||
    isNil(state.session.data);
}
